import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { startStreamingResponse } from '../start-streaming-response';
import { getSupportedMarkdowns } from './utils/get-supported-markdown-from-schema';
import { streamResponseParser } from './utils/stream-response-parser';
/**
 * Transforms some text
 *
 * Intended for use in EditorPluginAI config items.
 * @example
 * ```ts
 * triggerPromptRequest({ initialContext }) {
 *   return transform(initialContext.doc);
 * }
 * ```
 *
 * @see https://hello.atlassian.net/wiki/spaces/CA3/pages/2485466879/Generative+AI+API+Specs
 */
export var streamXPGenAI = function streamXPGenAI(input, customEndpoint) {
  return function promptRequest(requestOptions) {
    var streamingResponseGenerator = startStreamingResponse(_objectSpread({
      endpoint: customEndpoint || requestOptions.generativeAIApiUrl,
      payload: JSON.stringify(_objectSpread(_objectSpread({
        intentSchemaId: input.intentSchemaId,
        contextList: input.contextList,
        modelPlatform: 'OPENAI',
        outputLocale: input.userLocale,
        streaming: true,
        outputFormat: {
          outputFormatType: 'MARKDOWN',
          markdowns: getSupportedMarkdowns(input.editorSchema)
        },
        product: requestOptions.product
      }, 'customPrompt' in input && input.customPrompt && {
        userInstruction: input.customPrompt
      }), 'targetTranslationLanguage' in input && input.targetTranslationLanguage && {
        targetTranslationLanguage: input.targetTranslationLanguage
      }))
    }, requestOptions));
    return streamResponseParser(_objectSpread({
      streamingResponseGenerator: streamingResponseGenerator
    }, 'streamingListener' in input && input.streamingListener && {
      streamingListener: input === null || input === void 0 ? void 0 : input.streamingListener
    }));
  };
};